import { red, teal, yellow } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'


export const dark = createTheme({
  palette: {
    primary: {
      main: teal[600],
    },
    secondary: {
      main: yellow[700],
    },
    error: {
      main: '#ff4569',
    },
    background: {
      default: '#202020',
      paper: '#202020',
    },
    mode: 'dark',
  },
})
const light = createTheme({
  palette: {
    primary: {
      main: teal[700],
    },
    secondary: {
      main: yellow[700],
    },
    error: {
      main: red[600],
    },
    background: {
      default: '#fafafa',
    },
  },
})

function getDefaultDarkMode(): boolean {
  if (window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  }

  return false
}

const getTheme = (darkMode?: boolean | null) => {
  const calculatedDarkMode = darkMode === null ? getDefaultDarkMode() : darkMode
  return calculatedDarkMode ? dark : light
}

export default getTheme
